import React, { useEffect } from 'react';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import ModalLayout from '@wix/da-ds/pkg/modals/dsPresets/Modal/ModalLayout';
import { ModalRoot } from '@wix/da-ds/pkg/modals/base';
import s from './SidePanel.scss';
const SidePanel = ({ header, footer, children, onRequestClose, editor })=>{
    // Allow scrolling so editor can scroll when the panel is open
    useEffect(()=>{
        if (editor.storage['da-inside-modal'] !== true) {
            document.body.style.overflowY = 'scroll';
        }
        return ()=>{
            if (editor.storage['da-inside-modal'] !== true) {
                document.body.style.overflowY = 'auto';
            }
        };
    }, [
        editor.storage
    ]);
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        themeSurface: ThemeSurface.TERTIARY
    }, /*#__PURE__*/ React.createElement(ModalRoot, {
        isOpen: true,
        className: s['panel-modal'],
        useTransparentOverlay: true,
        onRequestClose: onRequestClose,
        useFixedMobileHeight: true,
        shouldCloseOnOverlayClick: false,
        bodyScrollLockOptions: {
            allowTouchMove: (el)=>{
                // Slider
                // Inputs like ranges
                return el.closest('.menu-scrollable') !== null || el.tagName === 'INPUT' || el.closest('input') !== null;
            }
        }
    }, /*#__PURE__*/ React.createElement(ModalLayout, {
        className: s['container'],
        header: header,
        headerBorder: true,
        content: children,
        contentClassName: s['modal-content'],
        footerBorder: true,
        footer: /*#__PURE__*/ React.createElement("div", {
            className: s['footer']
        }, footer)
    })));
};
SidePanel.displayName = 'SidePanel';
export default SidePanel;

//# sourceMappingURL=SidePanel.js.map